<div class="mb-32">
  <span class="title title--big">Нормативы</span>
</div>

<app-tabs [justifyContent]="'center'" [tabActive]="tabActiveManual" (tabChange)="onTabChange($event)">
  <app-tab [title]="'Нормативы работ'" [id]="NORMATIVES_PATHS.work_standards"></app-tab>
  <app-tab [title]="'Нормативы скорости'" [id]="NORMATIVES_PATHS.speed_standards"></app-tab>
</app-tabs>

<router-outlet></router-outlet>
